import React from "react";
import ConfirmModal from "../ConfirmModalBase";
import { ConfirmModalProps } from "../types";
import Trash from "../../../assets/icons/Trash.svg";

const ConfirmDeleteUserModal: React.FC<ConfirmModalProps> = ({ open, onClose, onConfirm }) => {
  return (
    <ConfirmModal
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      message="Are you sure you want to delete this user?"
      leftButtonText="Cancel"
      rightButtonText="Delete"
      imagePath={Trash}
    />
  );
};

export default ConfirmDeleteUserModal;
